<template>
  <SupporterButton
    v-if="supporterType"
    v-bind="{title}"
    body="Thanks so much for your support"
    aria-label="Update your membership"
    :type="supporterType"
    :disabled="isFetchingUrl"
    @click="handleClick"
  />
  <SupporterModalButtonView v-else />
</template>

<script lang="ts" setup>
import SupporterButton from "@/components/SupporterButton.vue";
import useMembershipStore from "@/stores/useMembershipStore";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import SupporterModalButtonView from "./SupporterModalButtonView.vue";

const {
  supporterType,
} = storeToRefs(useMembershipStore());

const {
  fetchCustomerPortalUrl,
} = useMembershipStore();

const isFetchingUrl = ref(false);

const title = computed(() => {
  switch (supporterType.value) {
    case "OfficialSponsor":
      return "You’re an official sponsor!";
    case "Supporter":
    case "Believer":
    case "Backer":
    default:
      return `You’re a ${supporterType.value?.toLowerCase() || "supporter"}!`;
  }
});

async function handleClick () {
  isFetchingUrl.value = true;

  const {
    url,
    error,
  } = await fetchCustomerPortalUrl();

  if (url) {
    window.location.href = url;
  } else if (error) {
    alert(error.message);
    isFetchingUrl.value = false;
  }
}
</script>
